<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">

        <a-form-model
          layout="vertical"
          :rules="rules"
          :model="user"
          ref="form"
        >
          <a-form-model-item
            :label="$t('accountSettings.nickname')"
            ref="nickName"
            prop="nickName"
          >
            <a-input v-model="user.nickName" :placeholder="$t('accountSettings.inputNickname')" :maxLength="30" />
          </a-form-model-item>

          <a-form-model-item
            :label="$t('accountSettings.mobile')"
            prop="phonenumber"
          >
            <a-input v-model="user.phoneNumber" :placeholder="$t('accountSettings.inputMobile')"/>
          </a-form-model-item>
          <a-form-model-item
            :label="$t('accountSettings.email')"
            prop="email"
          >
            <a-input v-model="user.email" :placeholder="$t('accountSettings.inputEmail')"/>
          </a-form-model-item>
          <a-form-model-item
            :label="$t('accountSettings.sex')"
            prop="sex"
          >
            <a-radio-group v-model="user.sex">
              <a-radio :value="sexValue.men">{{ $t('accountSettings.male') }}</a-radio>
              <a-radio :value="sexValue.women">{{ $t('accountSettings.female') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" :loading="submitLoading" @click="submit">{{ $t('common.save') }}</a-button>
          </a-form-model-item>
        </a-form-model>

      </a-col>
      <a-col :md="24" :lg="8" :style="{ minHeight: '180px' }">
        <div class="ant-upload-preview" @click="$refs.modal.edit(1)" >
          <a-icon type="cloud-upload-o" class="upload-icon"/>
          <div class="mask">
            <a-icon type="plus" />
          </div>
          <a-avatar :size ="180" :src="user.avatar || avatar"/>
        </div>
      </a-col>

    </a-row>

    <avatar-modal ref="modal" @ok="setavatar"/>

  </div>
</template>

<script>
import AvatarModal from './AvatarModal'
import { getUserProfile, updateUserProfile } from '@/api/system/user'
import { mapGetters } from 'vuex'

export default {
  name: 'BaseSettings',
  components: {
    AvatarModal
  },
  data () {
    return {
      submitLoading: false,
      // cropper
      sexValue: {
        men: 1,
        women: 2
      },
      user: {},
      preview: {},
      option: {
        img: "",
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1]
      },
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar']),
    rules() {
      return {
        nickName: [
          { required: true, message: this.$t('accountSettings.nicknameRequired') }
        ],
        email: [
          { required: false, message: this.$t('accountSettings.emailRequired') },
          {
            type: 'email',
            message: this.$t('accountSettings.emailFormatError'),
            trigger: ['blur', 'change']
          }
        ],
        phonenumber: [
          { required: false, message: this.$t('accountSettings.mobileRequired') },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: this.$t('accountSettings.mobileFormatError'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    this.getUser()
  },
  methods: {
    getUser () {
      getUserProfile().then(response => {
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    setavatar (url) {
      console.log('新头像URL:', url)
      // 更新 user 对象中的 avatar 字段，确保提交时包含正确的头像路径
      if (this.user) {
        this.user.avatar = url
      } else {
        this.user = { avatar: url }
      }
      // 同时更新 store 中的头像（已在 AvatarModal 中更新，这里确保同步）
      console.log('更新后的 user.avatar:', this.user.avatar)
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        // 确保提交时包含最新的头像路径
        const submitData = {
          ...this.user,
          avatar: this.user.avatar || this.avatar
        }
        console.log('提交的用户数据:', submitData)
        updateUserProfile(submitData).then(response => {
          this.$notification.open({
            message: this.$t('accountSettings.tip'),
            description: this.$t('accountSettings.updateSuccess'),
            icon: <a-icon type="check" style="color: #1890FF" />,
            duration: 3
          })
          // 保存成功后，更新 Vuex store 中的昵称和头像，使右上角显示立即刷新
          if (this.user.nickName) {
            this.$store.commit('SET_NAME', this.user.nickName)
          }
          if (this.user.avatar) {
            const avatar = this.user.avatar === '' ? require('@/assets/images/profile.jpg') : this.user.avatar
            this.$store.commit('SET_AVATAR', avatar)
          }
          // 重新获取用户信息以同步最新数据
          this.getUser()
        }).catch(error => {
          console.error('保存失败:', error)
          this.$message.error(this.$t('accountSettings.saveFailed'))
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.2);
      z-index: 1;
    }
    .mask {
      opacity: 0;
      position: absolute;
      background: rgba(0,0,0,0.4);
      cursor: pointer;
      transition: opacity 0.4s;
      z-index: 1;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
